import * as React from 'react';
import { Switch, Route } from 'react-router';
import ApplyToOriginal from '../ApplyToOriginal';

import InvoiceView from 'src/pages/InvoiceView';
import ApplyToOldest from '../ApplyToOldest';
import ApplyCreditOriginal from '../ApplyCredit/ApplyCreditOriginal';
import { PaymentDesktop } from '../PayRemaining/index';
import ManuallyCredit from '../ManuallyApplySelectCredit';
import ApplyCreditSuccess from '../ApplyCredit/ApplyCreditSuccessful/ApplyCreditSuccess';
import PayRemainingSuccess from '../ApplyCredit/PayRemainingSuccess';
import PayResponse from '../PayRemaining/PayResponse';
export interface IInvoiceRouteProps {
  selected: 'apply';
  match: any;
  pageNumber: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
  onSearch: (
    dateFrom?: string,
    dateTo?: string,
    search?: string,
    sort?: string,
    status?: string,
    size?: number,
    page?: number
  ) => void;
}

class InvoiceRoute extends React.Component<IInvoiceRouteProps, any> {
  public handlePageSizeChange = (pageSize: any) => {
    this.props.onSearch(
      this.state.dateStart,
      this.state.dateEnd,
      this.state.searchText !== ''
        ? `${this.state.searchOption.value},${this.state.searchText}`
        : null,
      this.state.sortBy !== ''
        ? `${this.state.sortBy},${this.state.sortOrder}`
        : null,
      this.state.status.value,
      pageSize ? pageSize : 20,
      null
    );
  };
  private handlePagination = (pageNumber: any) => {
    this.props.onSearch(
      this.state.dateStart,
      this.state.dateEnd,
      this.state.searchText !== ''
        ? `${this.state.searchOption.value},${this.state.searchText}`
        : null,
      this.state.sortBy !== ''
        ? `${this.state.sortBy},${this.state.sortOrder}`
        : null,
      this.state.status.value,
      this.props.pageSize,
      pageNumber ? pageNumber - 1 : 0
    );
  };
  public render() {
    return (
      <div>
        <Switch>
          <Route
            exact={true}
            path={`${this.props.match.path}`}
            component={InvoiceView}
          />
          <Route path={`${this.props.match.path}/applyOriginal`}>
            <ApplyToOriginal
              totalPages={20}
              pageNumber={1}
              pageSize={5}
              handlePagination={this.handlePagination}
              handlePageSizeChange={this.handlePageSizeChange}
            />
          </Route>
          <Route path={`${this.props.match.path}/applyOldest`}>
            <ApplyToOldest
              totalPages={20}
              pageNumber={1}
              pageSize={5}
              handlePagination={this.handlePagination}
              handlePageSizeChange={this.handlePageSizeChange}
            />
          </Route>
          <Route path={`${this.props.match.path}/applyCredit`}>
            <ApplyCreditOriginal />
          </Route>
          <Route path={`${this.props.match.path}/applySuccess`}>
            <ApplyCreditSuccess />
          </Route>
          <Route path={`${this.props.match.path}/applyPayRemainingSuccess`}>
            <PayRemainingSuccess />
          </Route>
          <Route path={`${this.props.match.path}/payResponse`}>
            <PayResponse />
          </Route>
          <Route path={`${this.props.match.path}/payRemaining`}>
            <PaymentDesktop />
          </Route>
          <Route path={`${this.props.match.path}/manualCredit`}>
            <ManuallyCredit
              totalPages={20}
              pageNumber={1}
              pageSize={5}
              handlePagination={this.handlePagination}
              handlePageSizeChange={this.handlePageSizeChange}
            />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default InvoiceRoute;
